export default {
  acceptSimulatedDuration: 'Prijať simulovanú dobu trvania',
  simulatedDuration: 'Simulovaná doba trvania',
  actualValue: 'Skutočná hodnota',
};
